import React, { useCallback, useMemo, useState } from 'react';
import { parseRenderOptions } from './utils';
import { FieldWrapper } from './FieldWrapper';
import classNames from 'classnames';
import { CertificateDetailsModal } from '../CertificateDetailsModal';

export const CertificateField = props => {
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = useCallback(() => setModalOpen(o => !o), []);

  const certificate = useMemo(
    () => (props.value && props.value.has('pem') ? props.value : null),
    [props.value],
  );

  const summary = useMemo(
    () =>
      certificate
        ? [
            {
              label: 'Subject',
              value: certificate.getIn(['subject', 'commonName']),
            },
            { label: 'Expires', value: certificate.get('validTo') },
            {
              label: 'Issuer',
              value: certificate.getIn(['issuer', 'commonName']),
            },
          ]
            .filter(o => !!o.value)
            .map(o => `${o.label}: ${o.value}`)
            .join(' --- ')
        : 'Not set',
    [certificate],
  );

  const renderOptions = parseRenderOptions(props, {
    isFloating: false,
  });

  return (
    <FieldWrapper {...props} renderOptions={renderOptions}>
      <div
        className={classNames('input-group', {
          'input-group-sm': renderOptions.size === 'sm',
        })}
      >
        <input
          className={classNames(
            'form-control flex-grow-1',
            renderOptions.fieldClassName,
            {
              'form-control-sm': renderOptions.size === 'sm',
            },
          )}
          type="text"
          readOnly
          id={props.id}
          name={props.name}
          value={summary}
          form={props.form}
        />
        {certificate && (
          <button
            className={classNames('btn btn-outline-primary', {
              'btn-sm': renderOptions.size === 'sm',
            })}
            type="button"
            onClick={toggleModal}
          >
            View Details
          </button>
        )}
      </div>
      {certificate && modalOpen && (
        <CertificateDetailsModal
          certificate={certificate}
          isOpen={modalOpen}
          toggle={toggleModal}
          title={
            renderOptions.custom.modalTitle ||
            `${props.label || 'Certificate'} Details`
          }
          downloadFilename={
            renderOptions.custom.filename ||
            `${props.name.replace('property_', '')}.crt`
          }
        />
      )}
    </FieldWrapper>
  );
};
